import React from "react";
import { BsClockHistory, BsTelephone, BsEnvelope } from "react-icons/bs";
import { openClose } from "./openClose";

const TopBar = () => {
	const isOpen = openClose();
	return (
		<div className='tb'>
			<div className='container'>
				<div className='tb-group'>
					<span className='tb-item'>
						<BsTelephone />
						<a className='tb-item' href='tel:015906224'>01-5906224</a>,
						<a className='tb-item' href='tel:9851279532'>9851279532</a>
					</span>
					<a className='tb-item' href='mailto:champawatisaving@gmail.com'>
						<BsEnvelope /> champawatisaving@gmail.com
					</a>
				</div>
				<div className='tb-group'>
					<span className='tb-item'>
						<BsClockHistory /> Sun–Fri 10am–5pm (सार्वजनिक बिदा बाहेक)
					</span>
					<span className='tb-item'>
						<span className={isOpen ? "tb-dot is-open" : "tb-dot"} />
						{isOpen ? "Open now" : "Closed now"}
					</span>
				</div>
			</div>
		</div>
	);
};

export default TopBar;
